/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Enable_Requires_LinkingInputs */

const he_account_delivery_enable_requires_linking = /** @type {(inputs: Account_Delivery_Enable_Requires_LinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חברו ערוץ זה לפני הפעלת התראות`)
};

const en_account_delivery_enable_requires_linking = /** @type {(inputs: Account_Delivery_Enable_Requires_LinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link this channel before enabling notifications`)
};

/**
* | output |
* | --- |
* | "Link this channel before enabling notifications" |
*
* @param {Account_Delivery_Enable_Requires_LinkingInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_enable_requires_linking = /** @type {((inputs?: Account_Delivery_Enable_Requires_LinkingInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Enable_Requires_LinkingInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_enable_requires_linking(inputs)
	return en_account_delivery_enable_requires_linking(inputs)
});